import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import packageJson from '../../package.json';

interface SplashScreenProps {
  onFinish: () => void;
}

export default function SplashScreen({ onFinish }: SplashScreenProps) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 2000);
    const finishTimer = setTimeout(() => onFinish(), 2500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ backgroundColor: '#e8e0ef' }}
    >
      {/* Center content */}
      <div className="flex flex-col items-center gap-5">
        {/* App Icon */}
        <div className="w-24 h-24 bg-white rounded-3xl shadow-lg flex items-center justify-center">
          <Heart size={44} className="text-[#fa8585] fill-[#fa8585]" />
        </div>

        {/* App Name */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-slate-800 tracking-tight">Nudge</h1>
          <p className="text-slate-400 text-base mt-1">Stay Connected</p>
        </div>

        {/* Loading bar */}
        <div className="w-16 h-1 bg-slate-300/50 rounded-full mt-4 overflow-hidden">
          <div className="h-full bg-slate-400/60 rounded-full animate-loading-bar" />
        </div>
      </div>

      {/* Bottom section */}
      <div className="absolute bottom-8 left-0 right-0 flex flex-col items-center">
        <p className="text-slate-400 text-xs">v{packageJson.version}</p>
      </div>
    </div>
  );
}
